import { useQuery } from "@tanstack/react-query";
import { Box } from "@mui/material";
import { ArrowRightAlt } from "@mui/icons-material";
import { ProjectServices } from "$services";
import { Text } from "$components";
import { Loader } from "$components/Layout/Loader";
import useOrder from "$hooks/useOrder";
import { CacheInvalidationAction } from "$utils/cache";

export const OrderRowSubComponent = ({
  projectId,
  dockyard,
  reference,
  suborderProducts,
  type,
}: any) => {
  const { data: project, isLoading: isLoadingProject } = useQuery({
    queryKey: [CacheInvalidationAction.GET_PROJECT_BY_ID, projectId],
    queryFn: () => ProjectServices.getProjectById(projectId),
    enabled: !!projectId,
    gcTime: 5 * 60 * 1000,
  });

  const { getSuborderTypeInfo } = useOrder();

  if (isLoadingProject) {
    return <Loader />;
  }

  return (
    <Box
      style={{ display: "flex", alignItems: "center" }}
      key={`subrow-item-${reference}`}
    >
      <ArrowRightAlt
        style={{ marginRight: 4, opacity: 0.6, fontSize: "1em" }}
      />
      <Text>
        N° {reference}, {suborderProducts?.length} produit
        {suborderProducts?.length > 1 && "s"} (
        {getSuborderTypeInfo(type, dockyard, project)})
      </Text>
    </Box>
  );
};
